//
// locale_sk.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/sk.json';
import localeData from "react-intl/locale-data/sk.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
